import React from 'react';
// import PropTypes from 'prop-types';
// import moment from 'moment';
import { Toolbar } from '@material-ui/core';
import ToggleTemp from 'components/Inputs/ToggleTemp';

const SettingsForm = () => {
  return (
    <Toolbar>
      <ToggleTemp />
    </Toolbar>
  );
};

SettingsForm.propTypes = {};

SettingsForm.defaultProps = {};

export default SettingsForm;
